import { render, staticRenderFns } from "./LomTrainingApproval.vue?vue&type=template&id=38da5e7f"
import script from "./LomTrainingApproval.vue?vue&type=script&lang=js"
export * from "./LomTrainingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports